import {
  Charge,
  ChargeKind,
  InstallmentPlanKind,
} from 'apollo/queries/autogenerate/schemas';
import { isApplePayment } from 'shared/modules/common/utils/charge-utils';

type Props = {
  handleAppleCharge: (charge: Charge) => void;
  handleNPayCharge: (charge: Charge) => void;
  handleStandardCharge: (charge: Charge) => void;
};

const useHandleViewCharge = (props: Props) => {
  const handleViewCharge = (charge: Charge) => {
    // TODO: Implement the 3 main flows.
    // Mixpanel.trackClickAction({
    //   screen,
    //   itemName: 'Charge',
    //   props: {
    //     [MIXPANEL_PROP.chargeType]: MIXPANEL_CHARGE_TYPE[charge.kind],
    //   },
    // });
    let isNPayInstallment = false;

    if (
      charge.installmentPlanOptions &&
      charge.installmentPlanOptions?.unavailable.length > 0
    ) {
      const installmentPlanOption =
        charge.installmentPlanOptions?.unavailable[0];

      isNPayInstallment =
        (installmentPlanOption.reason.details.kind ===
          InstallmentPlanKind.THREE_PAY ||
          installmentPlanOption.reason.details.kind ===
            InstallmentPlanKind.SIX_PAY ||
          installmentPlanOption.reason.details.kind ===
            InstallmentPlanKind.TWELVE_PAY) &&
        installmentPlanOption.reason.code === 'installment-charge';
    }

    if (
      isApplePayment(charge) &&
      charge.kind === ChargeKind.MULTI_PAY_CREDIT &&
      // If the user decided to cancel the multi-pay credit, the rest of the unpaid amount
      // will be charged all at once and will be labeled with 'キャンセル' on the text.
      // In this case, treat this as a standard Charge.
      // This may change in the future, but for now this is how we can detect an Apple multi-pay cancelled Charge.
      charge.description.indexOf('キャンセル') === -1
    ) {
      // TODO: apple installment charge.
      // redirectToAppleChargeDetail();
      props.handleAppleCharge(charge);
    } else if (isNPayInstallment) {
      // TODO: 3 pay installment charge.
      // NavigationService.navigate(Routes.PlusScreen.InstallmentPlanScreen, {
      //   id: installmentId,
      // });
      props.handleNPayCharge(charge);
    } else {
      // NavigationService.navigate(Routes.PlusScreen.ReceiptScreen, {
      //   charge,
      //   payment: charge.payment,
      //   combiniFee:
      //     charge.kind === ChargeKind.SETTLEMENT
      //       ? charge.metadata.settlementFeeAmount
      //       : null,
      //   isKYCed,
      // });
      props.handleStandardCharge(charge);
    }
  };

  return handleViewCharge;
};

export default useHandleViewCharge;
